export const ALVARA_VALIDAR = "tributario.obrasParticulares.alvara.ALVARA_VALIDAR";
export const ALVARA_GET = "tributario.obrasParticulares.alvara.ALVARA_GET";
export const ALVARA_SET = "tributario.obrasParticulares.alvara.ALVARA_SET";
export const ALVARA_IMPRIMIR = "tributario.obrasParticulares.alvara.ALVARA_IMPRIMIR";
